import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../context/LanguageContext';

const SearchOverlay = ({ isOpen, onClose, allProducts, onLogSearch }) => {
    const [searchQuery, setSearchQuery] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const navigate = useNavigate();
    const { t, getProductName } = useLanguage();

    useEffect(() => {
        if (!isOpen) {
            setSearchQuery('');
            setSearchResults([]);
            return;
        }

        if (searchQuery.trim() === '') {
            setSearchResults([]);
            return;
        }

        const lowerCaseQuery = searchQuery.toLowerCase();
        const results = allProducts
            .filter(product => {
                if (!product || !product.name) return false;

                return product.name.toLowerCase().includes(lowerCaseQuery) ||
                       (product.nameAr && product.nameAr.toLowerCase().includes(lowerCaseQuery)) ||
                       (product.keywords && product.keywords.some(kw => kw.includes(lowerCaseQuery)));
            })
            .slice(0, 10);

        setSearchResults(results);

        if(onLogSearch) {
            onLogSearch(lowerCaseQuery, results.length > 0);
        }
    }, [searchQuery, allProducts, isOpen, onLogSearch]);

    const handleResultClick = (productId) => {
        navigate(`/product/${productId}`);
        onClose();
    };

    if (!isOpen) return null;

    return (
        <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex flex-col items-center p-4" onClick={onClose}>
            <div className="w-full max-w-2xl" onClick={e => e.stopPropagation()}>
                <div className="relative">
                    <input 
                        type="text" 
                        autoFocus
                        placeholder={t('searchPlaceholder')}
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className="w-full p-4 pe-12 text-lg bg-white rounded-full shadow-lg outline-none"
                    />
                    <button onClick={onClose} className="absolute top-1/2 right-4 transform -translate-y-1/2 text-2xl text-gray-500 hover:text-gray-800" aria-label="Close">&times;</button>
                </div>

                {searchQuery.length > 2 && (
                    <div className="mt-4 bg-white rounded-lg shadow-lg max-h-[70vh] overflow-y-auto">
                        {searchResults.length > 0 ? (
                            <ul className="divide-y divide-gray-200">
                                {searchResults.map(product => (
                                    <li 
                                        key={product.id} 
                                        className="p-3 flex items-center gap-4 hover:bg-gray-100 cursor-pointer"
                                        onClick={() => handleResultClick(product.id)}
                                    >
                                        <img loading="lazy" src={product.imageUrls?.[0] || 'https://placehold.co/80x80/e2e8f0/1e293b?text=No+Image'} alt={getProductName(product)} className="h-16 w-16 object-cover rounded-md flex-shrink-0" />
                                        <div>
                                            <p className="font-semibold text-gray-900">{getProductName(product)}</p>
                                            <p className="text-sm text-gray-600">EGP {product.salePrice || product.price}</p>
                                        </div>
                                    </li>
                                ))}
                            </ul>
                        ) : (
                            <p className="p-4 text-gray-500">{t('noSearchResults', { query: searchQuery })}</p>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SearchOverlay;
